export const myProfileIds = {
  personalDetails: 'PersonalDetails',
  reports: 'Reports',
  tradingHistory: 'TradeHistory',
  documents: 'Documents',
  security: 'Security',
  helpCenter: 'HelpCenter',
  logout: 'Logout',
};
